export default {
    methods: {
        scrollTop() {
            window.$('html, body').animate({ scrollTop: 0 }, 'slow')
        },
        scrollToEl(elClass) {
            window.$('html, body').animate(
                {
                    scrollTop: window.$('.' + elClass).offset().top
                },
                'slow'
            )
        }
    }
}
